import { SvgIcon, Text, useText } from "@sveabank/cc-common";

type Props = {
	isSigned: boolean;
	signStepCompleted?: boolean;
	accepted?: boolean;
};

const SignStatusOther = ({ isSigned, signStepCompleted, accepted = true }: Props) => {
	const [t, texts] = useText();
	return (
		<div className="flex basis-4/12 justify-end gap-4">
			{isSigned || signStepCompleted ? (
				<>
					<SvgIcon imageSrc="SIGN_DONE" height={24} />
					<Text italic>
						{signStepCompleted && !isSigned
							? t(texts.signPage.package.signedDone)
							: t(texts.signPage.package.signed)}
					</Text>
				</>
			) : accepted ? (
				<Text italic>{t(texts.signPage.package.notSigned)}</Text>
			) : (
				<Text italic>{t(texts.signPage.package.notEligible)}</Text>
			)}
		</div>
	);
};

export default SignStatusOther;
